import { render } from "./OrientationAssessmentReport.vue?vue&type=template&id=15efeb19&scoped=true"
import script from "./OrientationAssessmentReport.vue?vue&type=script&lang=js"
export * from "./OrientationAssessmentReport.vue?vue&type=script&lang=js"

import "./OrientationAssessmentReport.vue?vue&type=style&index=0&id=15efeb19&scoped=true&lang=css"

import exportComponent from "/var/www/tis-live/frontend/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15efeb19"]])

export default __exports__